

(function layoutDirectiveDefinition() {

    angular.module('ui.Layout')
        .directive('layout', ['ui', 'config', function layoutDirectiveFactory(ui, config) {

            return {
                templateUrl: config.resourceUrl('/components/ui/layout/layout.html'),
                transclude: true,
                restrict: 'E',
                controller: ['$scope', '$element', '$attrs',
                    function layoutController($scope, $element, $attrs) {

                        $scope.$on('toggle-Nav-Menu', function (event, args) {
                            $scope.isNavClosed = args;
                        });

                        function setConfiguration(attr, key, defaultValue, remember) {
                            if ($attrs[attr] && $attrs[attr] === 'true') {
                                ui.configuration.initialize(key, remember, defaultValue);
                            }
                        }

                        ui.configuration.define('ui.layout.isNavbarFixed', true, false);
                        ui.configuration.define('ui.layout.isSidebarFixed', true, false);
                        ui.configuration.define('ui.layout.isSidebarClosed', true, true);
                        ui.configuration.define('ui.layout.isFooterFixed', true, false);
                        ui.configuration.define('ui.layout.hasSidebar', true, false);

                        var that = this;

                        function setClasses() {
                            that.classes = {
                                'app-mobile': ui.configuration.get('ui.isMobile'),
                                'app-navbar-fixed': ui.configuration.get('ui.layout.isNavbarFixed'),
                                'app-sidebar-fixed': ui.configuration.get('ui.layout.isSidebarFixed'),
                                'app-sidebar-closed': ui.configuration.get('ui.layout.isSidebarClosed'),
                                'app-footer-fixed': ui.configuration.get('ui.layout.isFooterFixed'),
                                'app-no-sidebar': !ui.configuration.get('ui.layout.hasSidebar'),
                                'app-has-sidebar': ui.configuration.get('ui.layout.hasSidebar')
                            };
                        }

                        $scope.$watchGroup([function () { return ui.configuration.get('ui.layout.isNavbarFixed'); },
                        function () { return ui.configuration.get('ui.layout.isSidebarFixed'); },
                        function () { return ui.configuration.get('ui.layout.isSidebarClosed'); },
                        function () { return ui.configuration.get('ui.layout.isFooterFixed'); },
                        function () { return ui.configuration.get('ui.layout.hasSidebar'); }],
                            function () {
                                setClasses();
                            });

                    }],
                controllerAs: 'layout'
            };

        }]);

})();